import env from 'enviro';
import { HUBSPOT_CREDITS_PAGE_V2 } from '../constants/Gates';
import { SEATS_VERSIONS_FEATURE_FLAG } from '../constants/PublicFeatureFlags';
import { SEATS_ACCESS } from '../constants/Scopes';
import { hasAnyMarketingPlusSkuInProductData } from './productsUtils';
import { getIsQAProxy } from './proxyUtils';
import safeLocalStorage from 'pricing-pages-ui-components/utils/safeLocalStorage';
export const getIsUngated = (state, {
  gateKey
}) => {
  var _gates$includes;
  const {
    gates
  } = state;
  const isQA = env.isQa() || getIsQAProxy();
  const override = safeLocalStorage.getItem(`${gateKey}_OVERRIDE`);
  if (override === 'true' && isQA) {
    return true;
  }
  return (_gates$includes = gates === null || gates === void 0 ? void 0 : gates.includes(gateKey)) !== null && _gates$includes !== void 0 ? _gates$includes : false;
};
export const getIsUngatedByForceSeatsPricingParam = () => new URLSearchParams(window.location.search).get('forceSeatsPricing') === 'true';
export const getIsUngatedForSeats = state => {
  const isUngatedByPublicFlagOrOverride = getIsUngated(state, {
    gateKey: SEATS_VERSIONS_FEATURE_FLAG
  });
  const isUngatedOnPublic = isUngatedByPublicFlagOrOverride || getIsUngatedByForceSeatsPricingParam();
  return isUngatedOnPublic || getIsUngated(state, {
    gateKey: SEATS_ACCESS
  });
};
export const getAreGatesPopulated = state => {
  return state.gates !== null && state.gates !== undefined;
};
export const getIsUngatedForMarketingPlus = state => {
  return hasAnyMarketingPlusSkuInProductData(state);
};
export const getIsUngatedForHubSpotCreditsPageV2 = state => getIsUngated(state, {
  gateKey: HUBSPOT_CREDITS_PAGE_V2
});